import Auth from '../api/auth';

const FINANCIAL_RESTRICTION_ERRORS = [
  'Account is suspended',
  'O período de teste desta empresa terminou',
  'O plano desta empresa está vencido',
];

const redirectFinanciallyRestrictedAccount = error => {
  const isFinancialRestriction =
    error?.response?.status === 401 &&
    FINANCIAL_RESTRICTION_ERRORS.includes(error.response?.data?.error);
  const accountMatch = window.location.pathname.match(/\/app\/accounts\/(\d+)/);

  if (!isFinancialRestriction || !accountMatch) return;

  const financialPath = `/app/accounts/${accountMatch[1]}/settings/billing`;
  if (window.location.pathname !== financialPath) {
    window.location.assign(financialPath);
  }
};

const parseErrorCode = error => {
  redirectFinanciallyRestrictedAccount(error);
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({
    baseURL: `${apiHost}/`,
    timeout: 120000, // 120 segundos (2 minutos) para suportar uploads grandes
  });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
